import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-box-select-gray",
  "use": "icon-box-select-gray-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-box-select-gray\"><path d=\"M812.46 769.86l134.23-66.9-393.58-154.72 156.25 395.34 61.3-132.27 146.75 147.01 43.25-44.8z\" p-id=\"14589\" fill=\"#707070\" /><path d=\"M928 63.34H98V840.72H512.1v-79.83H177.83V143.17h670.35v367.54H928V63.42z\" p-id=\"14590\" fill=\"#707070\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol